namespace TabAurous.Production {
    export namespace DismantlingItemsService {
        export const baseUrl = 'Production/DismantlingItems';

        export declare function Create(request: Serenity.SaveRequest<DismantlingItemsRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<DismantlingItemsRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<DismantlingItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: TransactionRequest, onSuccess?: (response: Serenity.ListResponse<DismantlingItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function ItemsList(request: TransactionRequest, onSuccess?: (response: Serenity.ListResponse<DismantlingItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Production/DismantlingItems/Create",
            Update = "Production/DismantlingItems/Update",
            Delete = "Production/DismantlingItems/Delete",
            Retrieve = "Production/DismantlingItems/Retrieve",
            List = "Production/DismantlingItems/List",
            ItemsList = "Production/DismantlingItems/ItemsList"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List', 
            'ItemsList'
        ].forEach(x => {
            (<any>DismantlingItemsService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
